// extracted by mini-css-extract-plugin
export default {"buttons":"RentalCheck_buttons__p2u+h","cancel":"RentalCheck_cancel__cZZub","next":"RentalCheck_next__2pIti"};